'use client';

import { slugify } from '../../Utils/helpers.js';

function createFormData(body) {
    var formData = new FormData();
    for (var _i = 0, _a = Object.entries(body); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (key && value !== null && value !== undefined) {
            formData.append(key, value);
        }
    }
    return formData;
}
var getJobUrlParams = function (link) {
    if (!link)
        return '';
    var urlSearch = link.split('?');
    if (!urlSearch || urlSearch.length < 1)
        return '';
    return urlSearch[1];
};
var applySuccessLink = function (baseUrl, t, jobInfo) {
    if (typeof window === undefined)
        return;
    var searchParams = new URLSearchParams(window.location.href);
    var isHaveCompetitiveParam = !!searchParams.has('applycompetitive');
    var alias = (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.alias) || slugify((jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobTitle) || '');
    var link = "".concat(baseUrl).concat(t('/success-apply'), "/").concat(alias, "-").concat(jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobId).concat(isHaveCompetitiveParam ? '?applycompetitive' : '');
    return link;
};

export { applySuccessLink, createFormData, getJobUrlParams };
//# sourceMappingURL=helper.js.map
